/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React Base Styles
import colors from "soft_dashboard/assets/theme/base/colors";
import borders from "soft_dashboard/assets/theme/base/borders";
import boxShadows from "soft_dashboard/assets/theme/base/boxShadows";

// Soft UI Dashboard React Helper Function
import rgba from "soft_dashboard/assets/theme/functions/rgba";

const { black } = colors;
const { borderWidth, borderRadius } = borders;
const { xxl } = boxShadows;

const card = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      backgroundColor: "#152737",
      backgroundClip: "border-box",
      border: `${borderWidth[0]} solid rgba(200,185,154,0.1)`,
      borderRadius: borderRadius.xl,
      boxShadow: xxl,
    },
  },
};

export default card;
